import React from "react";

import { connect } from "react-redux";

import ZeeTable from "components/ZeeTable";

import { createGroup, updateGroup, removeGroup } from "reducers/product";

import ProductStockGroupService from "services/product-stock-group";

class StockGroup extends React.Component {
  productStockGroupService = new ProductStockGroupService();

  columns = {
    name: { name: "Name" },
  };

  async onDelete(stockGroup) {
    const result = await this.productStockGroupService
      .delete(stockGroup)
      .then(({ data }) => data);

    if (result.success) {
      this.props.removeGroup(result.data);
      return result.data;
    }
    return false;
  }

  async onEdit(stockGroup) {
    const result = await this.productStockGroupService
      .update(stockGroup)
      .then(({ data }) => data);

    if (result.success) {
      this.props.updateGroup(result.data);
      return result.data;
    }
    return false;
  }

  async onAdd(stockGroup) {
    stockGroup.product_id = this.currentId;

    const result = await this.productStockGroupService
      .create(stockGroup)
      .then(({ data }) => data);

    if (result.success) {
      this.props.createGroup(result.data);
      return result.data;
    }
    return false;
  }

  onRowDoubleClick(item) {
    const { history } = this.props;
    history.push(`/products/${this.currentId}/stock/${item.id}`);
  }

  get currentId() {
    return this.props.product.id || null;
  }

  get currentItem() {
    return this.props.product || null;
  }

  get data() {
    return this.props.stockGroup.filter(
      (item) => item.product_id === this.currentId
    );
  }

  render() {
    return (
      <React.Fragment>
        <ZeeTable
          title="Stock Groups"
          columns={this.columns}
          data={this.data}
          orderBy="name"
          hasPagination={true}
          hasSort={true}
          hasDelete={true}
          hasEdit={true}
          hasAdd={true}
          onEdit={(product) => this.onEdit(product)}
          onDelete={(product) => this.onDelete(product)}
          onAdd={(product) => this.onAdd(product)}
          onRowDoubleClick={(item) => this.onRowDoubleClick(item)}
        />
      </React.Fragment>
    );
  }
}

export default connect(
  (state) => {
    return {
      stockGroup: state.product.group.all,
    };
  },
  { updateGroup, createGroup, removeGroup }
)(StockGroup);
